/*
 *
 * File: LegalNoticeScreen.jsx
 *
 * Purpose: Legal notice sreen for the user.
 *
 * Autor:   Thomas Burgard (Software development)
 * Created: 01.04.2022
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { Card } from "primereact/card";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import { getUserRegistrationData } from "../utils/utils";

//*************************************************************/
//* Variable declarations                                     */
//*************************************************************/
let userRegistrationDataObj = null;
//* End component variable declarations ***********************/

/**
 * Implementation of choose offer component.
 *
 * @returns JSX-HTML-DOM
 */
const LegalNoticeScreen = (props) => {
  const userData = props.userData;
  const { t, i18n } = useTranslation("common");

  userRegistrationDataObj = getUserRegistrationData(userData);

  //*************************************************************/
  //* Returns JSX code                                          */
  //*************************************************************/
  return (
    <>
      <Header userData={userData} />
      <div
        className="grid p-fluid"
        style={{ paddingLeft: "20px", paddingRight: "20px", marginTop: "30px" }}
      >
        <div className="col-12 md:col-12">
          <div style={{ marginBottom: "50px" }}>
            <Card style={{ backgroundColor: "#fcfcfc" }}>
              {userRegistrationDataObj.impressumFirmenName} <br />
              {userRegistrationDataObj.impressumFirmenStrasse} <br />
              {userRegistrationDataObj.impressumFirmenLand === "Deutschland" ? (
                <>
                  D-{userRegistrationDataObj.impressumFirmenPlz}{" "}
                  {userRegistrationDataObj.impressumFirmenStadt} <br />
                </>
              ) : null}
              Tel.: {userRegistrationDataObj.impressumFirmenTelefon} <br />
              E-Mail:{" "}
              <strong>{userRegistrationDataObj.impressumFirmenMail}</strong>
              <br />
              <br />
              {userRegistrationDataObj.impressumRechtsform !== "" ? (
                <>
                  <strong> Rechtsform: </strong>{" "}
                  {userRegistrationDataObj.impressumRechtsform} <br />
                </>
              ) : null}
              {userRegistrationDataObj.impressumGF !== "" ? (
                <>
                  <strong> Geschäftsführer: </strong>{" "}
                  {userRegistrationDataObj.impressumGF} <br />
                </>
              ) : null}
              {userRegistrationDataObj.impressumHRB !== "" ? (
                <>
                  <strong> HRB: </strong> {userRegistrationDataObj.impressumHRB}{" "}
                  <br />
                </>
              ) : null}
              {userRegistrationDataObj.impressumRegisterGericht !== "" ? (
                <>
                  <strong> Amtsgericht: </strong>{" "}
                  {userRegistrationDataObj.impressumRegisterGericht} <br />
                </>
              ) : null}
              {userRegistrationDataObj.impressumFirmenUstId !== "" ? (
                <>
                  <strong> UST-ID: </strong>{" "}
                  {userRegistrationDataObj.impressumFirmenUstId} <br />
                </>
              ) : null}
            </Card>
          </div>

          <div style={{ marginBottom: "100px" }}></div>

          <section style={{ marginBottom: "50px" }}>
            <h2>Dispute settlement</h2>
            <p>
              The EU has been providing an online platform at
              http://ec.europa.eu/consumers/odr/ since February 15, 2016 for
              dispute settlement in online trade. We are committed to you on
              this point out the possibility of online dispute resolution in
              accordance with Art. 14 Para. 1 ODR-VR. Our email you will find in
              the imprint. However, we are neither obliged nor willing to work
              on one dispute settlement proceedings before a consumer
              arbitration board.
            </p>
          </section>
        </div>
      </div>
      <Footer userData={userData} />
    </>
  );
};

export default LegalNoticeScreen;
